export function inHybridcast(): boolean {
  return Object.keys(navigator).indexOf('applicationManager') >= 0;
}
